import Route from '@ember/routing/route';

class WizardRoute extends Route {
  /**
   * @inheritDoc
   */
  redirect() {
    window.location.assign('/get-started/');
  }
}

export default WizardRoute;
